import * as fetch from 'isomorphic-fetch';

export const register = ({
  fullName,
  phoneNumber: phone_number,
  password,
  email,
}) =>
  new Promise((resolve, reject) => {
    fetch(`${__API_HOST__}/api/v1.1/register`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        full_name: fullName,
        phone_number,
        password,
        email,
      }),
    })
      .then(res => {
        if (res.ok) {
          return res.json();
        }
        return reject(res);
      })
      .then(json => resolve(json));
  });

export const verify = ({ id, verificationCode: verification_code }) =>
  new Promise((resolve, reject) => {
    fetch(`${__API_HOST__}/api/v1.1/register/verify`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id,
        verification_code,
        via: 'web',
      }),
    })
      .then(res => {
        if (res.status >= 200 && res.status < 300) {
          return res.json();
        }
        const error = new Error(res.statusText || 'Verification Failed.');
        throw error;
      })
      .then(json => resolve(json))
      .catch(e => reject(e));
  });

export const resend = ({ userId: id }) =>
  new Promise((resolve, reject) => {
    fetch(`${__API_HOST__}/api/v1.1/register/resend`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id,
      }),
    })
      .then(res => {
        if (res.status >= 200 && res.status < 300) {
          return res.json();
        }
        const error = new Error(res.statusText);
        throw error;
      })
      .then(json => resolve(json))
      .catch(e => reject(e));
  });



// WEBPACK FOOTER //
// ./app/actions/AuthenticationActionCreators.ts